













import Vue, { PropType } from "vue";

interface InquirySubmitButtonProps {
  actionUrl: string;
  buttonClass: string;
}

interface InquirySubmitButtonData {
  isLoading: boolean;
}

export default Vue.extend({
  name: "vc-inquiry-submit-button",
  props: {
    actionUrl: {
      type: String as PropType<InquirySubmitButtonProps["actionUrl"]>,
      default: "",
    },
    buttonClass: {
      type: String as PropType<InquirySubmitButtonProps["buttonClass"]>,
      default: "",
    },
  },
  data(): InquirySubmitButtonData {
    return {
      isLoading: false,
    };
  },
});
